import { ArrowRight, ShoppingBag, Star, Crown, Globe, Zap, Tag, Sparkles, X, BookOpen } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

const PLATFORM_BLOG = {
  "Amazon": "amazon-seller-central-india",
  "Flipkart": "flipkart-seller-onboarding",
  "Meesho": "meesho-supplier-registration",
  "Snapdeal": "snapdeal-seller-guide",
  "JioMart": "jiomart-express-seller-guide",
  "Shopsy": "flipkart-seller-onboarding",
  "Myntra": "myntra-onboarding-guide-2025",
  "Nykaa": "nykaa-onboarding-complete-process",
  "Nykaa Fashion": "nykaa-fashion-seller-guide",
  "Ajio": "ajio-seller-registration-guide",
  "Tata CLiQ": "tata-cliq-luxury-onboarding",
  "Purplle": "nykaa-onboarding-complete-process",
  "FirstCry": "firstcry-seller-registration",
  "Limeroad": "myntra-onboarding-guide-2025",
  "Myntra Luxe": "myntra-private-label-strategy",
  "Ajio Luxe": "ajio-seller-registration-guide",
  "Tata CLiQ Luxury": "tata-cliq-luxury-onboarding",
  "Aza Fashions": "tata-cliq-luxury-onboarding",
  "Pernia's Pop-Up Shop": "tata-cliq-luxury-onboarding",
  "Ogaan": "tata-cliq-luxury-onboarding",
  "Amazon US": "amazon-us-international-seller",
  "Amazon UAE": "noon-uae-seller-registration",
  "Walmart": "walmart-marketplace-india-brands",
  "Noon UAE": "noon-uae-seller-registration",
  "eBay": "ebay-international-selling",
  "Etsy": "etsy-india-sellers-guide",
  "Blinkit": "blinkit-vendor-registration",
  "Zepto": "zepto-seller-guide-2026",
  "Swiggy Instamart": "swiggy-instamart-onboarding",
  "BigBasket": "big-basket-seller-registration",
  "Flipkart Minutes": "flipkart-minutes-launch-strategy",
  "JioMart Express": "jiomart-express-seller-guide",
  "Myntra Private Label": "myntra-private-label-strategy",
  "Ajio Private Label": "ajio-seller-registration-guide",
  "Nykaa Private Label": "nykaa-cosmetics-private-labeling",
  "Zepto Private Label": "zepto-seller-guide-2026",
  "Aza Fashions Private Label": "fmcg-private-label-guide",
};

const CATEGORY_PLATFORMS = {
  starter: ["Amazon", "Flipkart", "Meesho", "Snapdeal", "JioMart", "Shopsy", "IndiaMART"],
  premium: ["Myntra", "Nykaa", "Nykaa Fashion", "Ajio", "Tata CLiQ", "Purplle", "FirstCry", "Limeroad"],
  luxe: ["Myntra Luxe", "Ajio Luxe", "Tata CLiQ Luxury", "Aza Fashions", "Pernia's Pop-Up Shop", "Ogaan"],
  international: ["Amazon US", "Amazon UAE", "Walmart", "Noon UAE", "eBay", "Etsy"],
  quickCommerce: ["Blinkit", "Zepto", "Swiggy Instamart", "BigBasket", "Flipkart Minutes", "JioMart Express"],
  privateLabeling: ["Myntra Private Label", "Ajio Private Label", "Nykaa Private Label", "Zepto Private Label", "Aza Fashions Private Label"],
};

const ServiceCategoryButtons = () => {
  const [selected, setSelected] = useState(null);
  const serviceCategories = [
    {
      id: "starter",
      title: "Starter Platforms",
      platforms: ["Amazon", "Flipkart", "Meesho", "Snapdeal"],
      count: "7+",
      icon: ShoppingBag,
      gradient: "from-emerald-500 to-teal-600",
      iconBg: "bg-emerald-100",
      iconColor: "text-emerald-600",
      hoverBorder: "hover:border-emerald-400"
    },
    {
      id: "premium",
      title: "Premium Platforms",
      platforms: ["Myntra", "Nykaa", "Ajio", "Tata Cliq"],
      count: "22+",
      icon: Star,
      gradient: "from-blue-500 to-indigo-600",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      hoverBorder: "hover:border-blue-400"
    },
    {
      id: "luxe",
      title: "Luxe Platforms",
      platforms: ["Myntra Luxe", "Aza Fashions", "Pernia"],
      count: "6+",
      icon: Crown,
      gradient: "from-purple-500 to-violet-600",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      hoverBorder: "hover:border-purple-400"
    },
    {
      id: "international",
      title: "International",
      platforms: ["Amazon US", "Walmart", "Noon UAE"],
      count: "8+",
      icon: Globe,
      gradient: "from-slate-600 to-slate-800",
      iconBg: "bg-slate-100",
      iconColor: "text-slate-600",
      hoverBorder: "hover:border-slate-400"
    },
    {
      id: "quickCommerce",
      title: "Quick Commerce",
      platforms: ["Blinkit", "BigBasket", "Swiggy Instamart"],
      count: "10+",
      icon: Zap,
      gradient: "from-red-500 to-rose-600",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      hoverBorder: "hover:border-red-400"
    },
    {
      id: "privateLabeling",
      title: "Private Labeling",
      platforms: ["Myntra", "Nykaa", "Ajio", "Zepto"],
      count: "5+",
      icon: Tag,
      gradient: "from-amber-500 to-orange-600",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
      hoverBorder: "hover:border-amber-400"
    },
    {
      id: "aiAutoListings",
      title: "AI Auto Listings Software",
      platforms: ["ecomcatalog.ai", "90-Sec Listings", "AI Data Analysis"],
      count: "NEW",
      icon: Sparkles,
      gradient: "from-violet-500 to-purple-600",
      iconBg: "bg-violet-100",
      iconColor: "text-violet-600",
      hoverBorder: "hover:border-violet-400",
      isExternal: true
    }
  ];

  const handleCategoryClick = (categoryId, isExternal) => {
    if (isExternal) {
      window.open('https://ecomcatalog.ai', '_blank');
      return;
    }
    setSelected(selected === categoryId ? null : categoryId);
    setTimeout(() => {
      const panel = document.getElementById('platform-onboarding-services');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 150);
  };

  return (
    <section id="services" className="py-14 md:py-20 px-4 bg-gradient-to-b from-white via-orange-50/40 to-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg text-xs font-black tracking-widest mb-6">
            <Sparkles size={14} />
            OUR SERVICES
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4">
            Choose Your Platform <span className="text-red-600">Category</span>
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            We specialize in onboarding across <span className="font-bold text-black">70+ marketplaces</span>
          </p>
        </div>

        {/* Premium Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {serviceCategories.map((category) => {
            const IconComponent = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => handleCategoryClick(category.id, category.isExternal)}
                className="group relative text-left bg-white rounded-2xl p-6 border-2 border-gray-100 transition-all duration-500 hover:-translate-y-2 hover:border-red-500 hover:shadow-[0_20px_60px_-15px_rgba(220,38,38,0.15)] overflow-hidden"
                data-testid={`category-button-${category.id}`}
              >
                {/* Top red accent line */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-red-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />

                {/* Icon + Count */}
                <div className="flex items-center justify-between mb-5">
                  <div className={`w-14 h-14 rounded-xl ${category.iconBg} flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3`}>
                    <IconComponent className={category.iconColor} size={26} />
                  </div>
                  <span className="px-3 py-1.5 bg-black text-white text-xs font-black rounded-lg">
                    {category.count}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-lg font-black text-black mb-4 group-hover:text-red-600 transition-colors">
                  {category.title}
                </h3>

                {/* Platform Tags */}
                <div className="flex flex-wrap gap-1.5 mb-5">
                  {category.platforms.map((platform, idx) => (
                    <span 
                      key={idx}
                      className="px-2.5 py-1 bg-gray-50 text-gray-700 text-xs rounded-lg font-semibold border border-gray-100 group-hover:border-red-100 group-hover:bg-red-50/50 transition-colors"
                    >
                      {platform}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <div className="flex items-center text-sm font-bold text-gray-400 group-hover:text-red-600 transition-colors">
                  <span>Start Selling Now</span>
                  <ArrowRight className="ml-2 transition-transform group-hover:translate-x-2" size={16} />
                </div>
              </button>
            );
          })}
        </div>

        {/* Our Platform Onboarding Services - expands on category click */}
        {selected && (
          <div id="platform-onboarding-services" className="mt-10 bg-slate-50 rounded-3xl p-6 md:p-8 border border-gray-100 shadow-inner" data-testid="platform-onboarding-panel">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-xl md:text-2xl font-black text-black">
                  Our Platform <span className="text-red-600">Onboarding Services</span>
                </h3>
                <p className="text-sm text-gray-500 font-semibold mt-1">
                  {serviceCategories.find((c) => c.id === selected)?.title} — select a platform to read its step-by-step onboarding guide
                </p>
              </div>
              <button onClick={() => setSelected(null)} aria-label="Close" data-testid="platform-panel-close" className="p-2 rounded-full hover:bg-gray-200 text-gray-500 transition-colors"><X size={18} /></button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
              {(CATEGORY_PLATFORMS[selected] || []).map((p, i) => (
                <Link
                  key={i}
                  to={PLATFORM_BLOG[p] ? `/blog/${PLATFORM_BLOG[p]}` : "/blog"}
                  className="group bg-white rounded-2xl p-4 border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:border-red-200 transition-all text-center"
                  data-testid={`platform-service-${i}`}
                >
                  <div className="w-11 h-11 mx-auto rounded-xl bg-gradient-to-br from-red-500 to-orange-500 text-white font-black text-lg flex items-center justify-center mb-2.5 group-hover:scale-110 transition-transform">
                    {p.charAt(0)}
                  </div>
                  <p className="font-black text-gray-900 text-sm leading-tight">{p}</p>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-1">Onboarding</p>
                  <span className="inline-flex items-center gap-1 mt-2 text-[11px] font-black text-red-600 group-hover:text-red-700">
                    <BookOpen size={11} /> Read Onboarding Guide <ArrowRight size={11} />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .text-gradient {
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>
    </section>
  );
};

export default ServiceCategoryButtons;
